var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoCalculadoraHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4264",
    "data-name": "Rect\\xE1ngulo 4264",
    width: 47.029,
    height: 60.527,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22192",
    "data-name": "Grupo 22192",
    transform: "translate(-776 -300)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1567",
    "data-name": "Elipse 1567",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(776 300)",
    fill: "#00a29a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22189",
    "data-name": "Grupo 22189",
    transform: "translate(802.486 319.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22189-2",
    "data-name": "Grupo 22189",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24597",
    "data-name": "Trazado 24597",
    d: "M36.4,0H10.627A10.629,10.629,0,0,0,0,10.629V49.9A10.629,10.629,0,0,0,10.627,60.527H36.4A10.627,10.627,0,0,0,47.029,49.9V10.629A10.628,10.628,0,0,0,36.4,0m8.287,49.261a8.926,8.926,0,0,1-8.926,8.926h-24.5A8.926,8.926,0,0,1,2.34,49.261V11.268A8.928,8.928,0,0,1,11.266,2.34h24.5a8.928,8.928,0,0,1,8.926,8.928Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24598",
    "data-name": "Trazado 24598",
    d: "M58.233,22.96H30.9a3.318,3.318,0,0,0-3.318,3.315v7.492A3.318,3.318,0,0,0,30.9,37.083H58.233a3.318,3.318,0,0,0,3.318-3.315V26.275a3.318,3.318,0,0,0-3.318-3.315m.978,9.621a2.161,2.161,0,0,1-2.162,2.162H32.082a2.161,2.161,0,0,1-2.162-2.162V27.462A2.163,2.163,0,0,1,32.082,25.3H57.049a2.163,2.163,0,0,1,2.162,2.162Z",
    transform: "translate(-21.127 -17.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24599",
    "data-name": "Trazado 24599",
    d: "M35,90.778H30.163a2.582,2.582,0,0,0-2.583,2.583v4.834a2.582,2.582,0,0,0,2.583,2.583H35a2.582,2.582,0,0,0,2.583-2.583V93.361A2.582,2.582,0,0,0,35,90.778m.243,7.66H29.92V93.118H35.24Z",
    transform: "translate(-21.127 -69.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24600",
    "data-name": "Trazado 24600",
    d: "M86.547,90.778H81.713a2.582,2.582,0,0,0-2.583,2.583v4.834a2.582,2.582,0,0,0,2.583,2.583h4.834a2.582,2.582,0,0,0,2.583-2.583V93.361a2.582,2.582,0,0,0-2.583-2.583m.243,7.66H81.47V93.118H86.79Z",
    transform: "translate(-60.616 -69.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24601",
    "data-name": "Trazado 24601",
    d: "M137.447,90.778h-4.834a2.582,2.582,0,0,0-2.583,2.583v4.834a2.582,2.582,0,0,0,2.583,2.583h4.834a2.582,2.582,0,0,0,2.583-2.583V93.361a2.582,2.582,0,0,0-2.583-2.583m.243,7.66H132.37V93.118h5.321Z",
    transform: "translate(-99.606 -69.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24602",
    "data-name": "Trazado 24602",
    d: "M35,141.56H30.163a2.582,2.582,0,0,0-2.583,2.583v4.834a2.582,2.582,0,0,0,2.583,2.583H35a2.582,2.582,0,0,0,2.583-2.583v-4.834A2.582,2.582,0,0,0,35,141.56m.243,7.66H29.92V143.9H35.24Z",
    transform: "translate(-21.127 -108.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24603",
    "data-name": "Trazado 24603",
    d: "M86.547,141.56H81.713a2.582,2.582,0,0,0-2.583,2.583v4.834a2.582,2.582,0,0,0,2.583,2.583h4.834a2.582,2.582,0,0,0,2.583-2.583v-4.834a2.582,2.582,0,0,0-2.583-2.583m.243,7.66H81.47V143.9H86.79Z",
    transform: "translate(-60.616 -108.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24604",
    "data-name": "Trazado 24604",
    d: "M35,192.342H30.163a2.582,2.582,0,0,0-2.583,2.583v4.834a2.582,2.582,0,0,0,2.583,2.583H35a2.582,2.582,0,0,0,2.583-2.583v-4.834A2.582,2.582,0,0,0,35,192.342M35.24,200H29.92v-5.321H35.24Z",
    transform: "translate(-21.127 -147.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24605",
    "data-name": "Trazado 24605",
    d: "M86.547,192.342H81.713a2.582,2.582,0,0,0-2.583,2.583v4.834a2.582,2.582,0,0,0,2.583,2.583h4.834a2.582,2.582,0,0,0,2.583-2.583v-4.834a2.582,2.582,0,0,0-2.583-2.583M86.79,200H81.47v-5.321H86.79Z",
    transform: "translate(-60.616 -147.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24606",
    "data-name": "Trazado 24606",
    d: "M137.447,143.791h-4.834a2.582,2.582,0,0,0-2.583,2.583v16.194a2.582,2.582,0,0,0,2.583,2.583h4.834a2.582,2.582,0,0,0,2.583-2.583V146.374a2.582,2.582,0,0,0-2.583-2.583m.243,19.02H132.37v-16.68h5.321Z",
    transform: "translate(-99.606 -110.148)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCalculadoraHome);
export default __webpack_public_path__ + "static/media/Icono_Calculadora_Home.066f4e187415ab8737f33921c98190b1.svg";
export { ForwardRef as ReactComponent };